import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const BROWARDBUSSTOP_LAYER_ID = 'browardBusStopLayer';

const ICONS = {
  'Bus Stop': require('../../../assets/bus.png'),
};

const layerConfig = {
  title: 'Bus stops',
};

function BrowardBusStopLayer() {
  const dispatch = useDispatch();
  const { browardBusStopLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, browardBusStopLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (browardBusStopLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: BROWARDBUSSTOP_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: browardBusStopLayer.visible,
      opacity: browardBusStopLayer.opacity,

      pointType: 'icon',
      getIcon: (d) => {
        return {
          url: ICONS['Bus Stop'],
          width: 128,
          height: 128,
          anchorY: 128,
        };
      },
      getIconSize: () => 12,
      iconSizeUnits: 'pixels',
      iconSizeScale: 2,
      iconBillboard: true,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: BROWARDBUSSTOP_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              title: 'Bus Stop Details',
              includeColumns: [
                'Transit_Type',
                'Location_Name',
                'Location_Type',
                'Stop_Route_IDs',
              ],
            }),
          };
        }
      },
    });
  }
}

export default BrowardBusStopLayer;
